import { render, staticRenderFns } from "./UiOrdersContainer.vue?vue&type=template&id=5c5c6308&"
import script from "./UiOrdersContainer.vue?vue&type=script&lang=js&"
export * from "./UiOrdersContainer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports